import { iframeResize } from "iframe-resizer";

window.scrollTo({
  top: 0,
  behavior: "smooth",
});

let iframeContent = document.getElementById("iframeResizer");

iframeResize(
  {
    log: true,
    onmessage: function (messageData) {
      if (messageData === "scrollToTop") {
        iframeContent.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
  "#iframeResizer"
);
